export const styles = () => ({
  content: {
    padding: 20,
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/seasons/styles.ts